import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { handlePaymentReturnPageLoad } from './utils/paymentReturnUtils';

const isPaymentReturnPath = () => {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  return path === '/payment-return' || path === '/payment-return.html';
};

const renderPaymentReturnFallback = () => {
  if (document.getElementById('payment-return-shell')) return;

  const root = document.getElementById('root');
  if (!root) return;

  root.innerHTML = `
    <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#f4f8fc;font-family:Inter,Arial,sans-serif;color:#195a8a;">
      <div style="max-width:28rem;width:calc(100% - 2rem);padding:2rem;border-radius:0.75rem;border:1px solid #d6e8f5;background:#fff;text-align:center;box-shadow:0 1px 3px rgba(0,0,0,.08);">
        <h1 style="margin:0 0 .75rem;font-size:1.25rem;">Payment complete</h1>
        <p style="margin:0;color:#4b5563;font-size:.875rem;line-height:1.5;">
          You can close this window and return to YokiHub.
        </p>
        <button
          type="button"
          onclick="window.close()"
          style="margin-top:1.25rem;border:0;border-radius:.375rem;background:#14b2e2;color:#fff;font-size:.875rem;font-weight:600;padding:.5rem 1rem;cursor:pointer;"
        >
          Return to YokiHub
        </button>
      </div>
    </div>
  `;
};

if (isPaymentReturnPath()) {
  handlePaymentReturnPageLoad();
  renderPaymentReturnFallback();
} else {
  Promise.all([
    import('./App'),
    import('./app/store'),
    import('react-redux'),
  ]).then(([{ default: App }, { store }, { Provider }]) => {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
      <Provider store={store}>
        <App />
      </Provider>,
    );
  });
}
